// Real-user monitoring for Core Web Vitals.
// Reports LCP, CLS, INP, FCP, TTFB to the GTM dataLayer so any analytics
// destination wired up in Tag Manager (GA4, Meta, custom HTTP endpoint, etc.)
// can receive them. Also mirrors the metric to console in development.

import { onLCP, onCLS, onINP, onFCP, onTTFB, type Metric } from "web-vitals";

type DataLayerWindow = Window & { dataLayer?: Array<Record<string, unknown>> };

function report(metric: Metric) {
  const w = window as DataLayerWindow;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({
    event: "web_vitals",
    web_vitals_metric: metric.name,
    web_vitals_value: Math.round(metric.name === "CLS" ? metric.value * 1000 : metric.value),
    web_vitals_raw_value: metric.value,
    web_vitals_rating: metric.rating, // 'good' | 'needs-improvement' | 'poor'
    web_vitals_delta: metric.delta,
    web_vitals_id: metric.id,
    web_vitals_navigation_type: metric.navigationType,
    page_path: window.location.pathname,
  });

  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.info(
      `[web-vitals] ${metric.name} = ${metric.value.toFixed(2)} (${metric.rating})`,
    );
  }
}

export function initWebVitals() {
  try {
    onLCP(report);
    onCLS(report);
    onINP(report);
    onFCP(report);
    onTTFB(report);
  } catch {
    /* non-critical */
  }
}
